import React, { ReactNode } from 'react'
import { useLocation } from 'react-router'
import { DarkModeProvider } from 'core/contexts/DarkThemeContext'
import { LayoutHeader } from 'core/components/layout/LayoutHeader'
import { CurrentHeaderProvider } from 'core/contexts/CurrentHeaderContext'
import { ROUTE_PATHS } from 'core/constants/routePath'

interface LayoutWrapperProps {
  children: ReactNode
  layoutClassName?: string
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  layoutClassName = 'layout-container',
}) => {
  const isDebug = useLocation().pathname.startsWith(ROUTE_PATHS.IADOCS_DEBUG)

  return (
    <DarkModeProvider>
      <CurrentHeaderProvider>
        <div className={layoutClassName}>
          {!isDebug && <LayoutHeader />}
          {children}
        </div>
      </CurrentHeaderProvider>
    </DarkModeProvider>
  )
}
